import {useMutation} from "@tanstack/react-query";

import {createSupplierOfferMutationOptions} from "./create-supplier-offer.mutation-options";

export function useCreateSupplierOffer() {
  return useMutation(createSupplierOfferMutationOptions());
}
